export default __webpack_public_path__ + "static/media/speed.a4751d11.svg";